import { FilterItem } from "@/components/FilterPopup";
import { OrderType, Payments } from "@/constants";
import {
    PendingOrderStatus,
    operateType,
    statusText,
} from "@/constants/order/key";

export const PENDING_FILTERS: FilterItem[] = [
  {
    title: "收款方式",
    key: "paymentType",
    multiple: true,
    items: [
      { value: `${Payments.BANK}`, text: "银行卡转账" },
      { value: `${Payments.WE_CHAT}`, text: "微信转账" },
      { value: `${Payments.ALI}`, text: "支付宝转账" },
      { value: `${Payments.DIGITAL_RMB}`, text: "数字人民币转账" },
    ],
  },
  {
    title: "状态",
    key: "status",
    multiple: true,
    items: [
      {
        value: `${PendingOrderStatus.INTRANSACTION}`,
        text: statusText[`${PendingOrderStatus.INTRANSACTION}`],
      },
      {
        value: `${PendingOrderStatus.HANGING}`,
        text: statusText[`${PendingOrderStatus.HANGING}`],
      },
    ],
  },
  {
    title: "是否可拆分",
    key: "isSplit",
    multiple: false,
    items: [
      {
        value: `${OrderType.SEPARABLY}`,
        text: `${operateType[`${OrderType.SEPARABLY}`]}拆分`,
      },
      {
        value: `${OrderType.INSEPARABLY}`,
        text: `${operateType[`${OrderType.INSEPARABLY}`]}拆分`,
      },
    ],
  },
];

export const parseParamsToFilters = (params: any) => {
  const filters: Record<string, string[]> = {};
  if (params.isSplit) {
    filters.isSplit = [`${params.isSplit}`];
  }
  if (params.paymentTypes && Array.isArray(params.paymentTypes)) {
    filters.paymentType = [...params.paymentTypes];
  }
  let status: string[] = [];
  if (params.inProgress !== undefined && params.inProgress !== "") {
    status.push(`${PendingOrderStatus.INTRANSACTION}`);
  }
  if (params.status !== undefined && params.status !== "") {
    status.push(`${PendingOrderStatus.HANGING}`);
  }
  if (status.length) {
    filters.status = [...status];
  }
  return filters;
};

export const formatFiltersToParams = (filters: Record<string, string[]>) => {
  const params: Record<string, any> = {};
  if (filters.isSplit && filters.isSplit.length) {
    params.isSplit = filters.isSplit[0];
  } else {
    params.isSplit = undefined;
  }

  if (filters.paymentType && filters.paymentType.length) {
    params.paymentType = filters.paymentType.reduce(
      (previous, current) => Number(previous) + Number(current),
      0,
    );
    params.paymentTypes = filters.paymentType;
  } else {
    params.paymentTypes = [];
    params.paymentType = undefined;
  }

  if (filters.status && filters.status.length) {
    if (filters.status.includes(`${PendingOrderStatus.INTRANSACTION}`)) {
      // params.isTransacting = '1'
      params.inProgress = 1;
    } else {
      params.inProgress = undefined;
    }

    if (filters.status.includes(`${PendingOrderStatus.HANGING}`)) {
      // params.isHanging = '1'
      params.status = 1;
    } else {
      params.status = undefined;
    }
  } else {
    params.inProgress = undefined;
    params.status = undefined;
  }

  return params;
};
